import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { computed,onMounted,ref } from 'vue';
import { data } from './composables/useData';
import { method } from './composables/useMethod';
import { useRoute,useRouter } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
  const router = useRouter();

  const reportList = computed(() => data.loginUser.viewReports.filter((v1,i1,a1) => a1.findIndex(v2 => v1.accountName === v2.accountName) === i1));


return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (!_unref(route).meta.hideAppBar)
            ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
                key: 0,
                modelValue: _unref(data).naviDrawer,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(data).naviDrawer) = $event)),
                app: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    opend: _unref(data).list.open,
                    "onUpdate:opend": _cache[4] || (_cache[4] = ($event: any) => ((_unref(data).list.open) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": "mdi-home",
                        title: "ホーム",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
                      }),
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": "mdi-home",
                        title: "ログイン",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/loginpage')))
                      }),
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": "mdi-home",
                        title: "サインアップ",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/signuppage')))
                      }),
                      _createVNode(_component_v_list_group, { value: "GA4レポート" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, {
                            title: "GA4レポート",
                            "prepend-icon": "mdi-account"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportList.value, (menu, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: index,
                              "prepend-icon": menu.icon,
                              onClick: ($event: any) => (_unref(method).menu.next(_unref(router), menu.accountId, index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, {
                                  textContent: _toDisplayString(menu.accountName)
                                }, null, 8, ["textContent"])
                              ]),
                              _: 2
                            }, 1032, ["prepend-icon", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": "mdi-home",
                        title: "設定",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/settingspage')))
                      })
                    ]),
                    _: 1
                  }, 8, ["opend"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (!_ctx.$route.meta.hideAppBar)
            ? (_openBlock(), _createBlock(_component_v_app_bar, {
                key: 1,
                app: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_nav_icon, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(data).naviDrawer = !_unref(data).naviDrawer))
                  }),
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(data).loginUser.activeReportData.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})